/**
 * PGLP | Google Maps / Geocodificação
 *
 * As requisições ao Google são feitas pelo backend do PGLP.
 * A chave do Google nunca é exposta ao navegador.
 */

export const construirEnderecoCompleto = (dados) => {
  const partes = [
    dados?.logradouro,
    dados?.numero,
    dados?.bairro,
    dados?.cidade,
    dados?.uf,
    dados?.cep,
    'Brasil'
  ]
    .map((item) => String(item || '').trim())
    .filter(Boolean);

  return partes.join(', ');
};


const normalizarPayload = (dados) => {
  const origem = typeof dados === 'string' ? { endereco: dados } : (dados || {});

  return {
    endereco: String(origem.endereco || origem.logradouro || '').trim(),
    numero: String(origem.numero || '').trim(),
    bairro: String(origem.bairro || '').trim(),
    cidade: String(origem.cidade || '').trim(),
    uf: String(origem.uf || '').trim().toUpperCase(),
    cep: String(origem.cep || '').replace(/\D/g, '').slice(0, 8)
  };
};

export const buscarCoordenadas = async (enderecoCompletoOuObjeto) => {
  const payload = normalizarPayload(enderecoCompletoOuObjeto);

  const response = await fetch('/api/imovel/geocodificar.php', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(payload)
  });

  let data = null;
  try {
    data = await response.json();
  } catch (error) {
    throw new Error('Resposta inválida do servidor de geocodificação.');
  }

  if (!response.ok || !data?.success) {
    throw new Error(data?.error || 'Não foi possível geocodificar o endereço.');
  }

  return data;
};

export const validarEndereco = async (dados) => {
  try {
    const result = await buscarCoordenadas(dados);
    return {
      valido: true,
      resultado: result
    };
  } catch (error) {
    return {
      valido: false,
      resultado: null,
      erro: error.message
    };
  }
};
